
    import { computed, defineComponent, onBeforeMount, onMounted, ref } from 'vue'

    import { useI18n } from 'vue-i18n-composable'
    import { Song } from '@/common/models/data/dashboard/song'
    import { sideBar } from '@/common/json-ld/page-elements'

    import AndroidAppDialog from '@/app/components/sidebar/AndroidAppDialog.vue'
    import Chat from '@/app/components/sidebar/chat/Chat.vue'
    import Player from '@/app/components/sidebar/player/Player.vue'
    import { useSidebarStore } from '@/app/stores/sidebar'

    export default defineComponent({
        components: {
            AndroidAppDialog,
            Chat,
            Player
        },
        setup () {
            const i18n = useI18n()
            const sidebarStore = useSidebarStore()

            const song = ref(new Song())

            const appDiscovered = computed(() => sidebarStore.appDiscovered)
            const appModalShown = computed(() => sidebarStore.appModalShown)
            const playerShown = computed(() => sidebarStore.playerShown)
            const chatShown = computed(() => sidebarStore.chatShown)

            const onAppDiscovered = (): void => {
                sidebarStore.appModalShown = false

                if (!appDiscovered.value) {
                    sidebarStore.appDiscovered = true
                }
            }

            const onAndroidAppModalClosed = (): void => {
                sidebarStore.appModalShown = false
            }

            const onSongChanged = (payload: Song): void => {
                song.value = payload
            }

            const togglePlayer = (): void => {
                sidebarStore.playerShown = !playerShown.value
            }

            const toggleChat = (): void => {
                sidebarStore.chatShown = !chatShown.value
            }

            onBeforeMount((): void => {
                song.value.artist = i18n.t('player.no-data').toString()
            })

            onMounted((): void => {
                if (!appDiscovered.value) {
                    window.setTimeout((): void => {
                        sidebarStore.appModalShown = true
                    }, 1000 * 60 * 5)
                }
            })

            return {
                appDiscovered,
                appModalShown,
                chatShown,
                jsonLd: sideBar,
                playerShown,
                song,
                onAndroidAppModalClosed,
                onAppDiscovered,
                onSongChanged,
                toggleChat,
                togglePlayer
            }
        }
    })
